import { ExpenditureService } from 'src/app/EBMSuite/services/expenditure/expenditure.service';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { ISibasiHTTPResponse } from '../model/sibasiHTTPResponse.model';
import { MemberService } from '../services/members/member.service';
import { UserService } from '../services/user/user.service';
import { IPagination, AutoCompleteSearchType } from '../model/util.model';
import { MultiSelectModule } from 'primeng/multiselect';
import { GroupService } from '../services/group/group.service';
import { OrganizationService } from '../services/organization/organization.service';
import { ItemCategoryService } from 'src/app/EBMSuite/services/item-categories/item-category.service';
import { ItemsService } from 'src/app/EBMSuite/services/items/items.service';
import { EmployeeService } from 'src/app/EBMSuite_HR/services/employee/employee.service';
import { ContactsService } from '../services/contacts/contacts.service';
import { PositionService } from 'src/app/EBMSuite_HR/services/position/position.service';
import { SibasiLocationService } from 'src/app/EBMSuite_HR/services/sibasi-location/sibasi-location.service';
import { AssetService } from 'src/app/EBMSuite/services/asset/asset.service';

@Component({
  standalone: true,
  selector: 'search-autocomplete',
  imports: [CommonModule, ReactiveFormsModule, AutoCompleteModule, MultiSelectModule],
  styles: `
    .p-element {
      width: 100%;
      display: flex;

      .p-mulitselect {
        width: 100% !important;
      }
    }
  `,
  template: `
    <div>{{ props.label }}</div>
    <p-multiSelect
      [options]="autoCompleteOptions"
      [formControl]="$any(formControl)"
      [optionLabel]="fieldName"
      [optionValue]="fieldValue"
      [selectionLimit]="selectionLimit"
      [maxSelectedLabels]="selectionLimit"
      [placeholder]="props.placeholder"
      [appendTo]="'body'"
      display="chip"
      class="mt-3"
      [required]="isRequired"
    />
  `
})
export class SearchMultiselectComponent extends FieldType implements OnInit {
  // Service
  private memberService = inject(MemberService);
  private userService = inject(UserService);
  private groupService = inject(GroupService);
  private organizationService = inject(OrganizationService);
  private itemService = inject(ItemsService);
  private itemCategoryService = inject(ItemCategoryService);
  private expenseService = inject(ExpenditureService);
  private contactService = inject(ContactsService);
  private cdr = inject(ChangeDetectorRef);
  private positionService = inject(PositionService);
  private locationService = inject(SibasiLocationService);
  private assetService = inject(AssetService);

  // Variables
  autoCompleteOptions: any[] = [];
  defaultPagination: IPagination<any[]> = {
    page: 0,
    pageSize: 20,
    searchParam: '',
    totalCount: 0,
    data: []
  };
  fieldName: string | undefined;
  fieldValue: string | undefined;
  searchConfig!:
    | {
        searchType: AutoCompleteSearchType;
        fieldName: string;
        fieldValue: string;
        multiple?: boolean;
        selectionLimit?: number | null;
      }
    | undefined;
  isLoading = false;
  selectionLimit: number | null = null;
  isRequired!: boolean;

  ngOnInit(): void {
    this.searchConfig = this.props['searchConfig'];
    this.fieldName = this.searchConfig?.fieldName;
    this.fieldValue = this.searchConfig?.fieldValue;
    this.selectionLimit = this.searchConfig?.selectionLimit || null;
    this.isRequired = this.props.required as boolean;

    this.search();
  }

  getServiceToQuery(
    defaultPagination: IPagination<any>
  ): Observable<ISibasiHTTPResponse<IPagination<any>>> | null | any {
    const searchType: AutoCompleteSearchType = this.searchConfig!.searchType;
    let searchService = null;

    switch (searchType) {
      case AutoCompleteSearchType.MEMBER:
        searchService = this.memberService.getPaginatedMembers(defaultPagination);
        break;
      case AutoCompleteSearchType.USER:
        searchService = this.userService.getAllUsersPagination(defaultPagination);
        break;
      case AutoCompleteSearchType.GROUP:
        searchService = this.groupService.getAllGroupsPagination(defaultPagination);
        break;
      case AutoCompleteSearchType.PAYYMENTTERMS:
        searchService = this.organizationService.getAllPaymentTermsPaginated();
        break;
      case AutoCompleteSearchType.ITEMCATEGORIES:
        searchService =
          this.itemCategoryService.getPaginatedCategories(defaultPagination);
        break;
      case AutoCompleteSearchType.ITEMS:
        searchService = this.itemService.getPaginatedItems(defaultPagination);
        break;
      case AutoCompleteSearchType.EXPENSESCATEGORIES:
        searchService = this.expenseService.getPaginatedCategories(defaultPagination);
        break;
      case AutoCompleteSearchType.EMPLOYEE:
        searchService = this.contactService.getPaginatedEmployees(defaultPagination);
        break;
      case AutoCompleteSearchType.CUSTOMER:
        searchService = this.contactService.getPaginatedCustomers(defaultPagination);
        break;
      case AutoCompleteSearchType.LEAD:
        searchService = this.contactService.getPaginatedLeads(defaultPagination);
        break;
      case AutoCompleteSearchType.LOCATION:
        searchService = this.locationService.getAllLocationsPagination(defaultPagination);
        break;
      case AutoCompleteSearchType.EMPLOYEE_POSITION:
        searchService = this.positionService.getAllPositionsPagination(defaultPagination);
        break;
      case AutoCompleteSearchType.ASSETCATEGORIES:
        searchService = this.assetService.getPaginatedCategories(defaultPagination);
        break;
      case AutoCompleteSearchType.ASSET:
        searchService = this.assetService.getPaginatedAssets(defaultPagination);
        break;
      default:
        searchService = null;
    }
    return searchService;
  }

  search(event?: { query: any }) {
    this.isLoading = true;
    // searchParam: event.query,
    this.defaultPagination = {
      ...this.defaultPagination
    };
    const searchService = this.getServiceToQuery(this.defaultPagination);
    if (!searchService) return;
    searchService.subscribe({
      next: (res: ISibasiHTTPResponse<IPagination<any>> | any) => {
        this.autoCompleteOptions = res.result.data
          ? [...res.result.data]
          : [...res.result];
        this.cdr.detectChanges();
        this.isLoading = false;
      },
      error: () => (this.isLoading = false)
    });
  }
}
